import { BrandFansActionTypes } from '@store/brandFans'

export const clearBrandFansErrors = () => ({
  type: BrandFansActionTypes.CLEAR_ERRORS,
})
